import { render, staticRenderFns } from "./InputPhotoProfile.vue?vue&type=template&id=31007750&scoped=true&lang=pug&"
import script from "./InputPhotoProfile.vue?vue&type=script&lang=ts&"
export * from "./InputPhotoProfile.vue?vue&type=script&lang=ts&"
import style0 from "./InputPhotoProfile.vue?vue&type=style&index=0&id=31007750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31007750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
